module.exports = __webpack_public_path__ + "static/media/sponsor2.6effdfa5.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/sponsor2.png
// module id = 98
// module chunks = 0